export default {"src":"/_next/static/media/Cornell.f8aefe38.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};